function formatArray(
  arr: VgsVariableArray,
  formValues: Record<string, unknown>,
): VgsVariableArray {
  return arr.map((item): unknown => {
    if (
      typeof item === 'object' &&
      '__type' in item &&
      item.__type === 'FORM_VALUE'
    ) {
      return formValues[item.name];
    } else if (Array.isArray(item)) {
      return formatArray(item, formValues);
    } else if (typeof item === 'object') {
      return formatObject(item, formValues);
    } else {
      return item;
    }
  });
}

function formatObject(
  obj: VgsRequestVariables,
  formValues: Record<string, unknown>,
): VgsRequestVariables {
  for (const key in obj) {
    if (!obj[key]) {
      continue;
    }
    if (typeof obj[key] === 'object') {
      if ('__type' in obj[key] && obj[key].__type === 'FORM_VALUE') {
        const fieldName = obj[key].name;
        obj[key] = formValues[fieldName];
      } else if (Array.isArray(obj[key])) {
        obj[key] = formatArray(obj[key], formValues);
      } else {
        obj[key] = formatObject(obj[key], formValues);
      }
    }
  }
  return obj;
}

export default formatObject;
